// source: type/order_total_price.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.OrderTotalPrice', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.OrderTotalPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.OrderTotalPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.OrderTotalPrice.displayName = 'proto.type.OrderTotalPrice';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.OrderTotalPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.type.OrderTotalPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.OrderTotalPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderTotalPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    inTaxTotalPrice: jspb.Message.getFieldWithDefault(msg, 1, 0),
    noTaxTotalPrice: jspb.Message.getFieldWithDefault(msg, 2, 0),
    inTaxProductPrice: jspb.Message.getFieldWithDefault(msg, 3, 0),
    noTaxProductPrice: jspb.Message.getFieldWithDefault(msg, 4, 0),
    subTotalPrice: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of OrderTotalPrice as accepted by the `fromObject` method.
 * @record
 */
proto.type.OrderTotalPrice.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.inTaxTotalPrice;

  /** @type {?|undefined} */
  this.noTaxTotalPrice;

  /** @type {?|undefined} */
  this.inTaxProductPrice;

  /** @type {?|undefined} */
  this.noTaxProductPrice;

  /** @type {?|undefined} */
  this.subTotalPrice;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.OrderTotalPrice.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.OrderTotalPrice}
 */
proto.type.OrderTotalPrice.fromObject = function(obj) {
  var msg = new proto.type.OrderTotalPrice();
  obj.inTaxTotalPrice != null && jspb.Message.setField(msg, 1, obj.inTaxTotalPrice);
  obj.noTaxTotalPrice != null && jspb.Message.setField(msg, 2, obj.noTaxTotalPrice);
  obj.inTaxProductPrice != null && jspb.Message.setField(msg, 3, obj.inTaxProductPrice);
  obj.noTaxProductPrice != null && jspb.Message.setField(msg, 4, obj.noTaxProductPrice);
  obj.subTotalPrice != null && jspb.Message.setField(msg, 5, obj.subTotalPrice);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.OrderTotalPrice}
 */
proto.type.OrderTotalPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.OrderTotalPrice;
  return proto.type.OrderTotalPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.OrderTotalPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.OrderTotalPrice}
 */
proto.type.OrderTotalPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInTaxTotalPrice(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNoTaxTotalPrice(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInTaxProductPrice(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNoTaxProductPrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubTotalPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.OrderTotalPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.OrderTotalPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.OrderTotalPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.OrderTotalPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInTaxTotalPrice();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNoTaxTotalPrice();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getInTaxProductPrice();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getNoTaxProductPrice();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSubTotalPrice();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 in_tax_total_price = 1;
 * @return {number}
 */
proto.type.OrderTotalPrice.prototype.getInTaxTotalPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.OrderTotalPrice} returns this
 */
proto.type.OrderTotalPrice.prototype.setInTaxTotalPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 no_tax_total_price = 2;
 * @return {number}
 */
proto.type.OrderTotalPrice.prototype.getNoTaxTotalPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.OrderTotalPrice} returns this
 */
proto.type.OrderTotalPrice.prototype.setNoTaxTotalPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 in_tax_product_price = 3;
 * @return {number}
 */
proto.type.OrderTotalPrice.prototype.getInTaxProductPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.OrderTotalPrice} returns this
 */
proto.type.OrderTotalPrice.prototype.setInTaxProductPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 no_tax_product_price = 4;
 * @return {number}
 */
proto.type.OrderTotalPrice.prototype.getNoTaxProductPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.OrderTotalPrice} returns this
 */
proto.type.OrderTotalPrice.prototype.setNoTaxProductPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 sub_total_price = 5;
 * @return {number}
 */
proto.type.OrderTotalPrice.prototype.getSubTotalPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.OrderTotalPrice} returns this
 */
proto.type.OrderTotalPrice.prototype.setSubTotalPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


goog.object.extend(exports, proto.type);
